export default "__VITE_ASSET__dc37569f__"